import { __rest } from "tslib";
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown as faCaretDownSolid, faSquareCheck as faSquareCheckSolid, faPencil as faPencilSolid } from '@fortawesome/pro-solid-svg-icons';
import { faCaretDown as faCaretDownLight, faChevronLeft as faChevronLeftLight, faChevronRight as faChevronRightLight } from '@fortawesome/pro-light-svg-icons';
import { faSquareQuestion as faSquareQuestionThin } from '@fortawesome/pro-thin-svg-icons';
import { faCaretDown as faCaretDownRegular, faSquare as faSquareRegular, faSearch as faSearchRegular } from '@fortawesome/pro-regular-svg-icons';
import { faCaretDown as faCaretDownDuotone } from '@fortawesome/pro-duotone-svg-icons';
import { cn, warn } from '~/utils';
const iconsByName = {
    solid: {
        'caret-down': faCaretDownSolid,
        'square-check': faSquareCheckSolid,
        pencil: faPencilSolid
    },
    regular: {
        'caret-down': faCaretDownRegular,
        square: faSquareRegular,
        search: faSearchRegular
    },
    light: {
        'caret-down': faCaretDownLight,
        'chevron-left': faChevronLeftLight,
        'chevron-right': faChevronRightLight
    },
    duotone: {
        'caret-down': faCaretDownDuotone
    },
    thin: {
        'square-question': faSquareQuestionThin
    }
};
const ICON_NAME = 'vulcanui-icon';
function findIcon(name, type) {
    if (name in iconsByName[type])
        return iconsByName[type][name];
    for (const [key, icons] of Object.entries(iconsByName)) {
        if (name in icons) {
            warn(`icon name "${name}" is not available in "${type}" style, using "${key}" instead`, 'Icon');
            return icons[name];
        }
    }
    return iconsByName.thin['square-question'];
}
function Icon(props) {
    const { name, type = 'solid', className } = props, restProps = __rest(props, ["name", "type", "className"]);
    const icon = React.useMemo(() => findIcon(name, type), [name, type]);
    return React.createElement(FontAwesomeIcon, Object.assign({ icon: icon, className: cn(ICON_NAME, className) }, restProps));
}
Icon.displayName = 'Icon';
Icon.toString = () => `.${ICON_NAME}`;
export default Icon;
//# sourceMappingURL=icon.js.map